import { BFFApiDomain } from "../serviceUtils";

export const getDoorListUrl = BFFApiDomain + "/fo-bff/api/priv/v1/{storeIdentifier}/{locale}/doors";
export const saveDoorListUrl =
  BFFApiDomain + "/fo-bff/api/priv/v1/{storeIdentifier}/{locale}/doors";
